export const search = ({ list, value, keys }) => {
  if (value) {
    const lowerCasedValue = value.toLowerCase();

    const searchedInput = list?.filter((item) => {
      const keysToCheck = keys.map((key) => item[key]);

      return keysToCheck.some((val) =>
        val?.toString()?.toLowerCase()?.includes(lowerCasedValue)
      );
    });

    return searchedInput;
  } else {
    return list;
  }
};
